import { clsx } from "clsx";
import { Cloud, CloudRain, CloudSun, type LucideIcon, Sun } from "lucide-react";
import type { WeatherCondition } from "../types.ts";

const CONDITION_ICON: Record<WeatherCondition, LucideIcon> = {
	sun: Sun,
	"cloud-sun": CloudSun,
	"cloud-rain": CloudRain,
	cloud: Cloud,
};

export function ConditionIcon({
	condition,
	className,
}: {
	condition: WeatherCondition;
	className?: string;
}) {
	const Icon = CONDITION_ICON[condition];
	return (
		<Icon
			data-condition={condition}
			className={clsx("weather-condition-icon", className)}
		/>
	);
}
